export var getValidVariant = function (variant) {
    switch (variant) {
        case 'primary':
        case 'secondary':
        case 'info':
        case 'warning':
        case 'danger':
        case 'success':
            return variant;
        default:
            return 'primary';
    }
};
